
































































































































































































































































import { Component, Watch, Vue } from 'vue-property-decorator'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import AppLogo from '@core/layouts/components/AppLogo.vue'
import {
  BRow,
  BCol,
  BLink,
  BButton,
  BForm,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BImg,
  BCardTitle,
  BCardText, BAlert, VBTooltip
} from 'bootstrap-vue'
import { required, email, confirmed } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { $themeConfig } from '@themeConfig'
import { Action, Getter } from '@/store/decorators'
import AuthModule from '@/store/modules/authModule'
import { RegisterPayload } from '@/models/Auth'
import { User } from '@/models/User'
import SocialLogin from '@/views/auth/SocialLogin.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { userAbility } from '@/libs/acl/config'
import { VueReCaptcha } from 'vue-recaptcha-v3'

@Component({
  name: 'Register',
  components: {
    BRow,
    BImg,
    BCol,
    BLink,
    BButton,
    BForm,
    BCardText,
    BCardTitle,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    SocialLogin,
    AppLogo,
    // validations
    ValidationProvider,
    ValidationObserver
  },
  mixins: [togglePasswordVisibility],
  directives: {
    'b-tooltip': VBTooltip
  }
})
export default class Login extends Vue {
  @Action(AuthModule, 'register') private registerUser!: (payload: RegisterPayload) => Promise<User>
  @Getter(AuthModule, 'activeUser') private activeUser!: User
  $refs!: { registerForm }

  private appName: string = $themeConfig.app.appName
  private status: string = ''
  private firstName: string = ''
  private lastName: string = ''
  private password: string = ''
  private passwordConfirmation: string = ''
  private userEmail: string = ''
  private sideImg: string = require('@/assets/images/pages/register-v2.svg')
  private passwordFieldType: string = 'password'
  private passwordConfirmationFieldType: string = 'password'
  private isTermsConditionAccepted:boolean| null =null

  private mounted () {
    const rules = [email, required, confirmed]
    Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY })
    if (this.activeUser) {
      const redirect = '' + (this.$router.currentRoute.query.to || '/')
      // console.log('redirect', redirect)
      this.$router.push(redirect).then().catch(() => {
      })
    }
  }

  private get passwordToggleIcon () {
    return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
  }

  private get imgUrl () {
    if (store.state.appConfig.layout.skin === 'dark') {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.sideImg = require('@/assets/images/pages/register-v2-dark.svg')
      return this.sideImg
    }
    return this.sideImg
  }

  private resetFields () {
    this.firstName = ''
    this.lastName = ''
    this.userEmail = ''
    this.password = ''
    this.passwordConfirmation = ''
    this.isTermsConditionAccepted = false
  }

  private async register () {
    this.$refs.registerForm.validate().then(success => {
      if (success) {
        this.handleRegisterUser()
      }
    })
  }
  private async handleRegisterUser () {
    await this.$recaptchaLoaded()
    const token = await this.$recaptcha('contact')
    if (token) {
      const payload: RegisterPayload = {
        firstName: this.firstName.toLowerCase(),
        lastName: this.lastName.toLowerCase(),
        email: this.userEmail.toLowerCase(),
        password: this.password,
        passwordConfirmation: this.passwordConfirmation
      }
      try {
        await this.registerUser(payload)
        if (this.activeUser) {
          const userRole = this.activeUser.userRole || 'public'
          this.$ability.update(userAbility[userRole])
          this.$router.replace(getHomeRouteForLoggedInUser(userRole))
            .then(() => {
              this.$toast({
                component: ToastificationContent,
                // position: 'top-right',
                props: {
                  title: 'Welcome',
                  icon: 'CoffeeIcon',
                  variant: 'success',
                  text: `You have successfully registered and logged in as customer Now you can start to explore!`
                }
              })
            })
            .catch(error => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: error.message,
                  icon: 'AlertTriangleIcon',
                  variant: 'danger'
                }
              })
            // console.log(error)
            // this.$refs.loginForm.setErrors(error.response.data.error)
            })
        }
      } catch (e) {
      // console.log(e)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: e.message,
            icon: 'AlertTriangleIcon',
            variant: 'danger'
          }
        })
      // console.log(e)
      }
    } else {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon: 'BellIcon',
          text: 'recaptcha error',
          variant: 'danger'
        }
      })
    }
  }

  @Watch('isTermsConditionAccepted')
  private updateTerms () {
    this.isTermsConditionAccepted = this.isTermsConditionAccepted || null
  }
}

